import getRequest from '../../getRequest';

/**
 */
const getScheduleDeployment = () => {
  const endpoint = '/deployment';
  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Deployement details')
        .then((response) => resolve(response))
        .catch((error) => reject(error));
  });
};

export default getScheduleDeployment;
